import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, CDN_URL, formatDate, getInlineLoader } from "../Helpers";


export default function View({ uuid }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [ data, setData ] = useState(null);

  async function init() {
    setReady(false);
    await Promise.all([
      getData(),
    ])
    setReady(true);
  }

  async function getData() {
    await callApi('get-gallery-data', { uuid }).then((response) => {
      if(response.status === 1) {
        setData(response.data);
      } else {
        appContext.tellError("Could not fetch data");
      }
    })
  }

  useEffect(() => {
    init();
  }, []);

  

  if (ready && data) {
    return (
      
      <div 
        className="container"
        
      >
        
    

        <div className="row">

          <div className="col-md-12">
            <h6
              className="main-section-title font-semi-bold"
            >
              {data.title}
            </h6>
          </div>

          
          <div className="col-md-12 mt-2 mb-2">
            <img
              src={CDN_URL + data.photo}
              style={{
                width: "100%"
              }}
            />
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{
                fontSize: "12px"
              }}
              className="text-end text-muted font-semi-bold"
            >
              {formatDate(data.dateCreated)}
            </h6>
            <hr/>
          </div>

          <div className="col-md-12 mt-2 mb-2">
            <h6
              style={{
                fontSize: "16px"
              }}
              className=""
            >
              {data.description}
            </h6>
          </div>
          
          
        </div>

        
      </div>
       
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
